// extracted by mini-css-extract-plugin
module.exports = {"previewContainer":"ActivityPreview_previewContainer__3FKtj"};